import axios from 'axios';

// Small request helper for <script setup> components, which can't use the
// global axiosCall mixin. Sends the same bearer token; throws on HTTP errors
// so callers can show the server's message.
const API = process.env.VUE_APP_SERVER;

export async function apiRequest(method, url, data, config = {}) {
  const token = localStorage.getItem('token');
  const res = await axios({
    method,
    url: API + url,
    data,
    ...config,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(config.headers || {}),
    },
  });
  return res.data;
}

// Nest returns { message } (string or list) on validation/guard errors.
export function errorMessage(error, fallback = 'Something went wrong. Please try again.') {
  // A request with no response never reached the API (server down, offline).
  if (error?.request && !error.response) {
    return 'Could not reach the server. Check your connection and try again.';
  }
  // Nest's own 500 body says "Internal server error", which tells a user
  // nothing; the caller's fallback names what failed.
  if (error?.response?.status >= 500) return fallback;
  const body = error?.response?.data;
  const msg = body?.message ?? body?.msg;
  if (Array.isArray(msg)) return msg.join(' ');
  return typeof msg === 'string' && msg ? msg : fallback;
}

// Many endpoints answer HTTP 200 with { status, msg } in the body, even on
// failure. Throw for those so callers can use a single try/catch.
export function assertOk(body, okStatuses = [200, 201]) {
  if (body && typeof body === 'object' && 'status' in body) {
    if (!okStatuses.includes(Number(body.status))) {
      const error = new Error(body.msg || body.message || 'Request failed.');
      error.response = { data: body };
      throw error;
    }
  }
  return body;
}
